// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SetNeedFullCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Parameters<typeof SetNeedFullCart>[0];

export const CustomSetNeedFullCart = (props: HandlerType) => {
    if (!("cartId" in props.parameter)) {
        return;
    }
    const pageType = getCurrentPage(props.getState()).type;
    props.needFullCart = props.needFullCart || pageType === "CheckoutShippingPage";
};

addToChainAfter(chain, SetNeedFullCart, CustomSetNeedFullCart);
